<template>
  <section>
    <v-layout row justify-center align-center class="my-3">
      <v-flex xs12 md8>
        <v-icon class="my-1" color="primary">account_balance</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Bienes</span>
      </v-flex>
    </v-layout>
    <v-stepper v-model="e6" vertical class="elevation-6">
      <v-stepper-step :complete="e6 > '1'" step="1" :editable='true'>Bienes Inmuebles Urbanos y Rurales</v-stepper-step>
      <v-stepper-content step="1">
        <BienesInmuebles v-if="e6 === '1'"></BienesInmuebles>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="accent" @click="e6 = '2'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '2'" step="2" :editable='true'>Bienes Muebles Sujetos a Registro</v-stepper-step>
      <v-stepper-content step="2">
        <bienesMuebles v-if="e6 === '2'"></bienesMuebles>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '1'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '3'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '3'" step="3" :editable='true'>Bienes Ajenos en Usufructo</v-stepper-step>
      <v-stepper-content step="3">
        <bienesAjenos v-if="e6 === '3'"></bienesAjenos>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '2'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '4'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '4'" step="4" :editable='true'>Depósitos en Entidades Financieras</v-stepper-step>
      <v-stepper-content step="4">
        <bienesDepositos v-if="e6 === '4'"></bienesDepositos>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '3'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '5'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '5'" step="5" :editable='true'>Títulos Valores</v-stepper-step>
      <v-stepper-content step="5">
        <bienesTitulos v-if="e6 === '5'"></bienesTitulos>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '4'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '6'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '6'" step="6" :editable='true'>Otros Bienes</v-stepper-step>
      <v-stepper-content step="6">
        <bienesOtros v-if="e6 === '6'"></bienesOtros>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '5'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '7'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '7'" step="7" :editable='true'>Remuneraciones</v-stepper-step>
      <v-stepper-content step="7">
        <bienesRenumeraciones v-if="e6 === '7'"></bienesRenumeraciones>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '6'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
        </v-flex>
      </v-stepper-content>
    </v-stepper>
    <v-layout align-center wrap>
      <v-flex md8 />
      <v-flex xs3 offset-xs9 align-end>
        <v-btn class="secondary" @click="$router.push('/datos-generales')"><v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior</v-btn>
        <v-btn color="accent" @click="$router.push('/deudas')">Siguiente&nbsp;<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
      </v-flex>
    </v-layout>
  </section>
</template>
<script>
import BienesInmuebles from '@/components/bienes/bienesInmuebles';
import BienesMuebles from '@/components/bienes/bienesMuebles';
import BienesAjenos from '@/components/bienes/bienesUsufructo';
import BienesDepositos from '@/components/bienes/bienesDepositos';
import BienesTitulos from '@/components/bienes/bienesTitulos';
import BienesOtros from '@/components/bienes/bienesOtros';
import BienesRenumeraciones from '@/components/bienes/bienesRenumeraciones';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [ Parametricas ],
  created () {
    // this.navBarEmmit();
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === 2) {
          this.$message['warning']('Su ultima Declaración no fue recepcionada, habilite la misma para terminarla');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === -1) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
      }
    });
    this.user = this.$storage.get('usuario');
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
  },
  components: {
    BienesInmuebles,
    BienesMuebles,
    BienesAjenos,
    BienesDepositos,
    BienesTitulos,
    BienesOtros,
    BienesRenumeraciones
  },
  data () {
    return {
      e6: '1'
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/declaracion/bienes.vue